import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import { getErrorMessage } from "../../../utils/GeneralUtils";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import SharedRecordAPI from "../../api/SharedRecordAPI";

interface Props {
  recordID: string;
  sharedRecordID: string;
  moduleAPIName: string;
  onSuccess: () => void;
  onError: (err: string) => void;
}

export default function useLeaveSharedRecordSync() {
  const client = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const leaveSync = useMutation({
    mutationFn: ({ recordID, sharedRecordID }: Props) => {
      return SharedRecordAPI.leaveSync(recordID, sharedRecordID).then(
        (data) => data.data.data.record
      );
    },
    onSuccess: (record, { moduleAPIName, recordID, onSuccess }) => {
      client.setQueryData(
        [tenantID, "record", moduleAPIName, recordID],
        record
      );
      client.invalidateQueries({ queryKey: ["userSharedRecord", recordID] });
      onSuccess();
    },
    onError: (err, { onError }) => {
      onError(getErrorMessage(err));
    },
  });

  return { leaveSync: leaveSync.mutate, leavingSync: leaveSync.isPending };
}
